import * as React from "react";
import Header from "./Header";
import PaymentManagementList from "../payments/PaymentManagementList";
import PaymentManagementDetail from "../payments/PaymentManagementDetail";

// Gestión de Pagos: recorrido financiero de las solicitudes de pago jurídicas
// (Causación → Contabilidad → Presupuesto → Tesorería → Caja). Módulo propio y
// no una pestaña de /financing: esa vista es el flujo de personas naturales y
// no cambia (legal-payment-financial-flow, D4).
export default function LayoutPaymentManagement({ detail }) {
  return (
    <>
      <Header />
      {detail ? <PaymentManagementDetail /> : <PaymentManagementList />}
    </>
  );
}
